// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__33zwj","footer":"ModalFilter_footer__2hJ4_"};